import React from 'react'
import ResponsiveModal, {
  ModalSizes,
  ResponsiveModalActions,
  ResponsiveModalBody,
} from '@src/components/ResponsiveModal/ResponsiveModal'
import { Button, Typography } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'

interface MaxOligoCountReachedModalProps {
  dialogOpen: boolean
  handleClose: () => void
  maxOligoCount: number
}

const MaxOligoCountReachedModal: React.FC<MaxOligoCountReachedModalProps> = ({
  dialogOpen,
  handleClose,
  maxOligoCount,
}) => {
  return (
    <ResponsiveModal
      open={dialogOpen}
      onClose={handleClose}
      size={ModalSizes.Small}
      renderTitle={() => (
        <Typography variant="h2" component="h2">
          <FormattedMessage
            id="CONF_MAX_COUNT_TITLE"
            defaultMessage="Maximum Limit Reached"
          />
        </Typography>
      )}
    >
      <ResponsiveModalBody>
        <FormattedMessage
          id="CONF_MAX_COUNT_REACHED_MESSAGE"
          defaultMessage="You have reached the maximum number of items per session. Maximum {maxOligoCount} items are allowed per session."
          values={{ maxOligoCount }}
        />
        <ResponsiveModalActions>
          <Button
            onClick={handleClose}
            color="primary"
            id="delete-cancel-button"
            data-testid="delete-cancel-button"
            variant="contained"
          >
            <FormattedMessage id="CONF_OK_MESSAGE" defaultMessage="OK" />
          </Button>
        </ResponsiveModalActions>
      </ResponsiveModalBody>
    </ResponsiveModal>
  )
}

export default MaxOligoCountReachedModal
